export function trimText(text, size) {
  if (text?.length > size) {
    return text?.substring(0, size) + '...';
  } else {
    return text;
  }
}